import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { parseUserKey, userKeys } from '../../cache-keys/userKeys';
import { lock_api } from '@axo/shared/data-access/api';
import { QueryFunctionContext, UseQueryOptions, useQuery } from 'react-query';
import { queryFunction } from '../../query-function';
import { lock } from '@axo/shared/data-access/types';

type QueryKey = ReturnType<(typeof userKeys)['lockedApplications']>;
function map({ queryKey }: QueryFunctionContext<QueryKey>): lock.FindRequest {
  const { user, country } = parseUserKey(queryKey);

  return {
    country,
    lockedBy: user,
  };
}

export function useLocks(
  country: string,
  user: string,
  options?: Omit<
    UseQueryOptions<unknown, unknown, lock.FindResult, QueryKey>,
    'queryKey' | 'queryFn'
  >
) {
  const cacheKey = userKeys.lockedApplications({
    user,
    country,
  });
  const api = useAPI();

  return useQuery(cacheKey, queryFunction(lock_api.find(api), map), options);
}

export function useCurrentUserLocks(country?: string) {
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);
  return useLocks(country ?? '', clientID, {
    enabled: !!country,
  });
}
